import { domToReact } from 'html-react-parser';
import React from 'react';
import ExternalLink from '../components/svgs/ExternalLink';

const parseLinkOption = {
  replace: (domNode) => parseLinkCallback(domNode),
};

export const parseLinkCallback = (domNode) => {
  if (domNode.name === 'a' && domNode.attribs.href.includes('http')) {
    return (
      <a href={domNode.attribs.href} target="_blank" rel="noopener noreferrer">
        {domToReact(domNode.children)}
        <span className={`inlineIcon`}>
          <ExternalLink />
        </span>
      </a>
    );
  }

  return domNode;
};

export default parseLinkOption;
